import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconEmailPlus: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"email-plus, envelope, add, plus"} maskId="square-filled-radius-0-stroke-1-IconEmailPlus"><path d="M12 10.4073L2 4.04371V4H22V4.04371L12 10.4073Z" fill="currentColor"/><path d="M2 20V5.22902L12 11.5927L22 5.22902V16H21V13H18V16H15V19H18V20H2Z" fill="currentColor"/><path d="M20 17H23V18H20V21H19V18H16V17H19V14H20V17Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconEmailPlus;
